import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Tooltip, Typography } from '@mui/material';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import styles from '../../styles/menu/ActionMenu.module.scss'

const MenuComponent = ({ menuItems, rowData, isDisabled = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Function to determine item variant based on action type
  const getItemVariant = (item) => {
    const name = item.name.toLowerCase();
    if (name.includes('add') || name.includes('create')) return 'primary';
    if (name.includes('delete') || name.includes('remove')) return 'danger';
    return 'default';
  };

  // Use description from menu item if provided
  const getItemDescription = (item) => {
    return item.description || '';
  };

  return (
    <div>
      <Tooltip title="Actions">
        <IconButton
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
          size="small"
          disabled={isDisabled}
        >
          <EllipsisVerticalIcon className="icon" />
        </IconButton>
      </Tooltip>

      <Menu
        id="menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          className: styles.menuPaper,
          style: {
            maxHeight: 300,
            overflowY: 'auto',
          },
        }}
        MenuListProps={{
          className: styles.menuList,
        }}
      >
        {menuItems.map((item, index) => {
          const variant = getItemVariant(item);
          const description = getItemDescription(item);
          const isDanger = variant === 'danger';
          const isPrimary = variant === 'primary';
          
          const menuItemClass = `${styles.menuItem} ${
            isPrimary ? styles.primaryAction : ''
          } ${isDanger ? styles.dangerAction : ''}`;

          return (
            <div key={index}>
              {/* Add divider before danger actions (like delete) */}
              {isDanger && index > 0 && <hr className={styles.divider} />}
              <MenuItem
                onClick={() => {
                  item.action(rowData);
                  handleClose();
                }}
                disabled={item.disabled}
                className={menuItemClass}
              >
                <div className={`${styles.iconContainer} ${styles[`iconContainer${variant.charAt(0).toUpperCase() + variant.slice(1)}`]}`}>
                  {React.cloneElement(item.icon, {
                    className: "icon",
                  })}
                </div>
                <div className={styles.textContainer}>
                  <p  
                     className={styles.title}>
                    {item.name}
                  </p>
                  {description && (
                    <p
                      className={`${styles.description} ${isDanger ? styles.descriptionDanger : ''}`}
                    >
                      {description}
                    </p>
                  )}
                </div>
              </MenuItem>
            </div>
          );
        })}
      </Menu>
    </div>
  );
};

export default MenuComponent;